<template>
  <div>
    <div class="card p-2">
      <div class="card-body">
        <div class="d-flex gap-10 flex-column flex-md-row">
          <membership class="" :level="currentLevel" :all-levels="allLevels" :next-level="nextLevel"></membership>
          <div class=" d-flex justify-content-center align-items-center flex-grow-1">
            <level-progress class="w-100" :amount-spent="amountSpent" :next-level-amount="nextLevel?.amount"></level-progress>
          </div>
          <membership class="" :level="nextLevel" :all-levels="allLevels"></membership>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Membership from './Membership'
import LevelProgress from './LevelProgress'
export default {
  name: "Level",
  props: ['currentLevel', 'amountSpent', 'allLevels', 'source'],
  components: {LevelProgress, Membership},
  computed: {
    sortedLevels() {
      return this.allLevels.slice().sort((a, b) => b.amount - a.amount);
    },
    nextLevel() {
      if (!this.currentLevel) return null;

      const currentIndex = this.sortedLevels.findIndex(item => item === this.currentLevel);
      const nextIndex = currentIndex + 1;

      return this.sortedLevels[nextIndex] || null;
    },
    membershipSpacing() {
      if (this.source == 'Admin') {
        return "col-md-3"
      }
      return "col-md-5"
    },
    progressSpacing() {
      if (this.source == 'Admin') {
        return "col-md-6"
      }
      return "col-md-8"
    }
  }
}
</script>

<style scoped>

</style>
